module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAzElEQVR4AZSQLQrCYACGP607gBZPIAarDMsOYxDRYFCwKVgFMdj1AAYvIMMLWGXdMITBus9jENNg8j2+e38G25qhxu9/POC+MWxhB6reHBuC44irCfTgBhuYgao3t48cxxQvOMIDSvCoenP72HFC04GqY584zlj1wZt8JC5/R29unznOqS7QhjUsYAqq3tw+d1xQNOAMczjBFVS9uX3hOKVowQi68IYnqHpz+9Sxb72n9M2H6Ar8zqre3L50TPc9d/4PsAS/s6o3JwrhAwAA//9a+YfgAAAABklEQVQDAMk2LhcVFd8rAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/converted_5.png
// module id = wwIY
// module chunks = 1